import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [data, setData] = useState(null);

  const navigate = useNavigate();

  const validateEmail = (email) => {
    var regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    return regex.test(email);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    setEmailError(!validateEmail(email));
    setPasswordError(password.length < 8);
    if(!passwordError && !emailError){
      localStorage.setItem('email', email);
    }
    navigate('/dashboard')
  };

  const handleSuccess = ({credential}) => {
    const credentialResponseDecoded = jwt_decode(credential);
    localStorage.setItem('picture', credentialResponseDecoded.picture);
    localStorage.setItem('email', credentialResponseDecoded.email);
    navigate('/dashboard');
  }

  const handleFaliure = (res) => {
    console.log(res);
  };

  return (
    <>
      <div className="Auth">
        <div className="Signin_Page">
          <h2>Sign In</h2>
          <p>Sign in to your account</p>

          <div className="oauth-buttons">
            <GoogleLogin onSuccess={handleSuccess} onError={handleFaliure} />
          </div>

          <form className="signin-form" onSubmit={handleFormSubmit}>
            <div className="input-group">
              <label>Email address</label>
              <input
                type="email"
                placeholder="johndoe@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {emailError && (
                <p
                  style={{
                    color: "red",
                    fontSize: "13px",
                    position: "absolute",
                  }}
                >
                  Invalid email address
                </p>
              )}
            </div>

            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {passwordError && (
                <p
                  style={{
                    color: "red",
                    fontSize: "13px",
                    position: "absolute",
                  }}
                >
                  Password must be at least 8 characters
                </p>
              )}
            </div>

            <div className="forgot-password">
              <a href="#">Forgot password?</a>
            </div>

            <button type="submit" className="signin-btn">
              Sign In
            </button>
          </form>

          <div className="register-link">
            Don't have an account? <a href="#">Register here</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Auth;
